'use client';

import { BackToTopArrow } from '@/assets';
import { cx } from '@/lib/utils';
import { useBackToTop } from './use-back-to-top';

export const BackToTop = () => {
  const { showScroll, scrollTop } = useBackToTop();

  return (
    <button
      className={cx(
        'fixed bottom-24 right-[calc(50%-28px)] transition-opacity duration-500 sm:right-16',
        showScroll ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
      onClick={scrollTop}
      aria-label="Back to top Button"
    >
      <BackToTopArrow className="size-16 rounded-full shadow-lg" />
    </button>
  );
};
